import { render, staticRenderFns } from "./ScrollingText.vue?vue&type=template&id=fadb68f0&scoped=true&lang=pug&"
import script from "./ScrollingText.vue?vue&type=script&lang=js&"
export * from "./ScrollingText.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingText.vue?vue&type=style&index=0&id=fadb68f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadb68f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fadb68f0')) {
      api.createRecord('fadb68f0', component.options)
    } else {
      api.reload('fadb68f0', component.options)
    }
    module.hot.accept("./ScrollingText.vue?vue&type=template&id=fadb68f0&scoped=true&lang=pug&", function () {
      api.rerender('fadb68f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/ScrollingText.vue"
export default component.exports